<template>
  <AuthenticatedLayout :nav="'hr'" :full-width="fullWidth" :narrow="narrow">
    <div class="flex-auto h-full">
      <slot />
    </div>
  </AuthenticatedLayout>
</template>
<script>
import AuthenticatedLayout from '@/Layouts/AuthenticatedLayout.vue';

const NARROW_COMPONENTS = ['HRAssistant/Index'];

export default {
  components: {
    AuthenticatedLayout,
  },
  computed: {
    fullWidth() {
      return this.$page.component === 'Jobs/KanbanView';
    },
    narrow() {
      return NARROW_COMPONENTS.includes(this.$page.component);
    },
  },
};
</script>
